export default "__VITE_ASSET__IeMCM7lC__"